import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class MapApi {
    constructor(private axios: AxiosInstance) {
    }

    resolve = async (): Promise<MapResolutionType> => {
        const {data} = await this.axios
            .withAuthentication()
            .get('/v1/resolve-map');

        return data as MapResolutionType;
    };

    setPlacePayload = async (definition: string, expanded: boolean) => {
        const {data} = await this.axios
            .withAuthentication()
            .post('/v1/map/set-place-payload', {
                definition: definition,
                expanded: expanded,
            });

        return data;
    };

    setMatterPayload = async (definition: string, icon: string) => {
        const {data} = await this.axios
            .withAuthentication()
            .post('/v1/map/set-matter-payload', {
                definition: definition,
                icon: icon,
            });

        return data;
    };

    resolveRoute = async (place: string): Promise<MapRouteType> => {
        const {data} = await this.axios
            .withAuthentication()
            .get('/v1/resolve-route', {
                params: {
                    place: place,
                },
            });

        return data as MapRouteType;
    };
}

export type MapResolutionType = {
    places: Array<{
        definition: string,
        name: string,
        current: boolean,
    }>;
    matters: Array<{
        definition: string;
        place: string;
        name: string;
    }>;
    placePayloads: Array<{
        definition: string;
        expanded: boolean;
    }>;
    matterPayloads: Array<{
        definition: string;
        icon: string;
    }>;
};

export type MapRouteType = Array<{
    type: string;
    definition: string;
    name: string;
}>;

decorate(injectable(), MapApi);
decorate(inject(AxiosInstance), MapApi, 0);

export {MapApi};
